module.exports = __webpack_public_path__ + "static/media/sso-ping.66b6a1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/sso-ping.png
// module id = 13916
// module chunks = 0